import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'clsx';

import styles from '../common-status-style.module.css';

export const CustomsErrorMessage = ({ error }) => {
  return (
    <div className={styles['message-wrapper']}>
      <FontAwesomeIcon className={classnames(styles.icon, styles.error)} icon={faExclamationCircle} />
      <span>{error}</span>
    </div>
  );
};

CustomsErrorMessage.propTypes = {
  error: PropTypes.string.isRequired,
};
